import { Typography } from "@/components/ui/typography";
import { WeatherDay } from "./WeatherCarousel";
import { HugeiconsIcon } from "@hugeicons/react";

export const WeatherCard = ({ day }: { day: WeatherDay }) => (
  <div className="flex items-center gap-2">
    <div>
      <Typography variant="bodySRegular">
        {Math.round(day.tempMin)}°/{" "}
        <Typography variant="h4Regular" as="span">
          {Math.round(day.tempMax)}°
        </Typography>
      </Typography>
      <Typography variant="captionRegular" className="text-[10px] text-left">
        {day.description}
      </Typography>
    </div>
    <HugeiconsIcon size={40} icon={day?.icon} className={day?.className} />
  </div>
);
